import { apiClient } from "./client";
import type { ConversionJob } from "../types/job";

export async function listJobs(): Promise<ConversionJob[]> {
    const { data } = await apiClient.get<{ jobs: ConversionJob[] }>("/jobs");
    return data.jobs;
}

export async function uploadJob(file: File): Promise<ConversionJob> {
    const form = new FormData();
    form.append("file", file);
    const { data } = await apiClient.post<ConversionJob>("/jobs", form);
    return data;
}

export async function getJob(jobId: string): Promise<ConversionJob> {
    const { data } = await apiClient.get<ConversionJob>(`/jobs/${jobId}`);
    return data;
}

export async function deleteJob(jobId: string): Promise<void> {
    await apiClient.delete(`/jobs/${jobId}`);
}

/** Direct, browser-navigable download link (same-origin, cookie-authenticated). */
export function downloadHref(jobId: string): string {
    const base = apiClient.defaults.baseURL ?? "/api/v1";
    return `${base}/jobs/${jobId}/download`;
}
